
const namespaced = true;
const defaultState = () => ({

  originData: [], //原始資料
  sources: [],
  dateRange: [], //日期範圍
  highchartColor: ["#ffc000", "#66bb6a", "#ed7d31", "#a5a5a5", "#5b9bd5"], // highchart color
  countPerDay: [], // 每日瀏覽、不重複瀏覽、平均瀏覽、平均停留
  browsingCount: 0, // 總瀏覽
  distinctCount: 0, // 總不重複瀏覽
  averageCount: 0, //總平均
  averageStaytime: 0,//停留時間
  totalReportHelpIcon: {},  // Total Report 的字卡說明

  totalReport: {}, //總體瀏覽報表

});
const state = defaultState();

const mutations = {

  resetState: (state) => Object.assign(state, defaultState()),
  // 原始資料
  setOriginData: (state, data) => (state.originData = data),
  // sources
  setSources: (state, sources) => (state.sources = [...sources]),
  // 日期範圍，不管有幾個 source，取第一筆資料的日期即可
  setDateRange: (state) => (state.dateRange = state.originData[0].data.map((el) => el.date)),

  // 瀏覽人數、不重複瀏覽人數、平均瀏覽/(天)
  setCountPerDay: (state) => {
    state.countPerDay = state.originData.map((item) => ({
      source: item.source,
      data: item.data.map((el) => {
        let objectPerDay = el.group.reduce(
          (total, current) => ({
            browsingCount:
              total.browsingCount + parseInt(current.browsing_count),
            distinctCount:
              total.distinctCount + parseInt(current.distinct_count),
            // staytime:
            //   total.staytime + parseInt(current.stayTime),
          }),
          { browsingCount: 0, distinctCount: 0 }
        );

        objectPerDay.averageCount =
          parseFloat(
            (objectPerDay.browsingCount / objectPerDay.distinctCount).toFixed(2)
          ) || 0;
        objectPerDay.averageStaytime = el.stayTime;

        return objectPerDay;
      }),
    }))
  },
  // 小卡片總瀏覽人數、總不重複瀏覽人數、總平均瀏覽
  setCardInfo: (state) =>
  ({
    bro: state.browsingCount,
    dis: state.distinctCount,
    // avg: state.averageCount,

    st: state.averageStaytime
   
  } = state.countPerDay.reduce(
    (total, current) => ({
      bro:
        total.bro +
        current.data.reduce(
          (totalGroupCount, group) => totalGroupCount + group.browsingCount,
          0
        ), // 總瀏覽
      dis:
        total.dis +
        current.data.reduce(
          (totalGroupCount, group) => totalGroupCount + group.distinctCount,
          0
        ), // 不重複瀏覽
      
        // avg:
      //   total.avg +
      //   current.data.reduce(
      //     (
      //       totalGroupCount,
      //       group //每日平均累計/總天數/來源數
      //     ) => totalGroupCount + group.averageCount / state.dateRange.length,
      //     0
      //   ) /
      //   state.countPerDay.length,

      st:
        total.st +
        current.data.reduce(
          (
            totalGroupCount,
            group
          ) => totalGroupCount + group.averageStaytime / state.dateRange.length,
          0
        ) /
        state.countPerDay.length,
    }),
    { bro: 0, dis: 0, avg: 0, st: 0 }
  )),
  //總平均瀏覽數
  setAverageBro: (state) => {
    state.averageCount = state.browsingCount / state.distinctCount
  },
  // 依點擊小卡片決定總體瀏覽報表資料
  setTotalReport: (
    state,
    cardItem = { title: "網頁瀏覽數", value: "browsingCount", helpIconAnnotation: "網頁的瀏覽數加總。重複瀏覽同一個網頁也計算在內", helpIconEnabled: true }
  ) => {
    const countPerDay = state.countPerDay;
    const { title, value } = cardItem;
    const totalReport = {
      chartTitle: title,
      series: [],
    };
    countPerDay.forEach((item, index) => {
      totalReport.series.push({
        name: state.sources[index],
        data: item.data.map((el) => el[value]),
      });
    });
    // 若來源兩個以上額外計算總合
    if (state.sources.length > 1) {
      const mergeData = []; // 總和線
      let mergeCount = 0; // 總和線各數值
      for (let index in totalReport.series[0].data) {
        mergeCount = totalReport.series.reduce(
          (total, currentSeries) =>
            (total * 100 + currentSeries.data[index] * 100) / 100,
          0
        ); //浮點數處理 *100 相加後 /100
        if (value === "averageCount" || value === "averageStaytime") {
          mergeCount /= countPerDay.length; // 平均瀏覽數為各來源的平均
        }
        mergeData.push(mergeCount);
      }
      totalReport.series.unshift({
        name: title,
        data: mergeData,
      });
    }
    totalReport.series.forEach(
      (el, index) => (el.color = state.highchartColor[index])
    ); //highchart color

    state.totalReportHelpIcon = { annotation: cardItem.helpIconAnnotation, enabled: cardItem.helpIconEnabled };
    state.totalReport = totalReport;
  },
}

const actions = {


  setOriginData: ({ commit }, data) => { //set origindata
    commit("setOriginData", data)
    commit("setDateRange")
    commit("setCountPerDay")

    commit("setCardInfo")
    commit("setTotalReport")
    commit("setAverageBro")
  },
};
const getters = {
  getDataSources: (state) => state.sources, // sources
  getDateRange: (state) => state.dateRange, // 日期範圍
  getCardInfo: (state) => (type) => (state[type] ? state[type] : 0), // 小卡片數字
  getTotalReport: (state) => state.totalReport, //總瀏覽數報表
  getTotalReportHelpIcon: (state) => state.totalReportHelpIcon, // 總攬列表字卡
};

export default { namespaced, state, actions, mutations, getters }